/**
 * Shared types and constants for the RunDetailModal component tree.
 */

import type { GetRunResponseContent } from "@/generated/sdk"
import type { QuarantineRecord, Severity } from "@/types/lineage"

export type { GetRunResponseContent, QuarantineRecord, Severity }

/**
 * Metadata keys added by the data quality engine that should not be displayed as record fields.
 */
export const QUARANTINE_META_KEYS = new Set([
  "DataQualityRulesPass",
  "DataQualityRulesFail",
  "DataQualityRulesSkip",
  "DataQualityEvaluationResult",
])

/**
 * Preferred columns to use as row identifiers when displaying quarantined records.
 */
export const PREFERRED_ID_COLUMNS = [
  "USUBJID",
  "SUBJID",
  "SITENUM",
  "COUNTRY",
  "EVENTDT",
  "SDCOMPDT",
]

/**
 * Terminal run statuses where polling should stop.
 */
export const TERMINAL_STATUSES = ["COMPLETED", "FAILED", "PARTIALLY_COMPLETED"]

/**
 * Entry in the shared rule numbering map. Assigns a display number and severity to each unique
 * rule.
 */
export interface RuleEntry {
  num: number
  severity: Severity
}

/**
 * Props for the shared RunDetailBody.
 */
export interface RunDetailBodyProps {
  /**
   * Study ID to fetch run data for.
   */
  studyId: string
  /**
   * Run ID to display.
   */
  runId: string
}
